import React, { useCallback, useEffect } from 'react';
import { VehicleForm } from '../vehicle-form/VehicleForm';
import PersonalForm from '../personal-form/PersonalForm';
import * as Yup from 'yup';
import {
    emailConfirm,
    patentWithoutVerifier,
    validateEmail,
    validateNativeRut,
    validatePatente,
    validateRequired
} from 'shared';
import { Formik, useFormikContext } from 'formik';
import { useOffers } from "hooks/useOffers";
import { registerAnalyticsEvent } from 'shared/utils/analytics';
import { Google_Analitys_Categories } from 'settings/data';
import { Toast } from 'components/index';


export const FormikEffect = ({ onChange }) => {
    const { values } = useFormikContext();

    useEffect(() => {
        onChange(values)
    }, [values, onChange])

    return null
}

export const GeneralData = React.forwardRef(({ userInfo, initialValues, updateGeneralData }, ref) => {
    const { price, hasDoublePromotion } = useOffers();

    const handleChange = useCallback(
        (values) => {
            updateGeneralData(values);
        },
        [updateGeneralData]
    )



    useEffect(() => {
        const { cat_new_report, ga_actions } = Google_Analitys_Categories;
        registerAnalyticsEvent({ category: cat_new_report, action: ga_actions.load, label: 'init_general_data_step' });
    }, [])

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={
                Yup.object().shape({
                    rut: validateNativeRut,
                    email: Yup.lazy((value, context) => {
                        return !userInfo ?
                            emailConfirm(value, context.parent.emailConfirm) :
                            validateEmail
                    }),
                    emailConfirm: Yup.lazy((value, context) => {
                        return !userInfo ?
                            emailConfirm(value, context.parent.email) :
                            Yup.string()
                    }),
                    name: validateRequired('El nombre es requerido.'),
                    phone: Yup.lazy((value, context) => {
                        return Yup.string().nullable().phone(context.parent.countryCode)
                    }),
                    patentes: Yup.lazy((value, context) => {
                        return Yup.array().of(Yup.object().shape({
                            vehicle: Yup.string().required(),
                            patente: Yup.lazy((patente, context) => Yup.string().when('vehicle', (vehicle, schema) => {
                                return validatePatente(vehicle).test(
                                    'unique-patente', 'No se debe repetir la misma patente.',
                                    () => value.filter(v => patentWithoutVerifier(v.patente || "") === patentWithoutVerifier(patente || "")).length <= 1
                                );
                            })),
                            reportType: Yup.array().min(1, "El Tipo de reporte es requerido.").required(1, "El Tipo de reporte es requerido.")
                        }))
                    }),
                    recaptcha: Yup.lazy((value, context) => (
                        !userInfo ?
                            Yup.string().required('Verificación de Google Recaptcha requerida.') :
                            Yup.string()
                    ))
                })}
            onSubmit={() => {
            }}
        >
            {
                (formik) => {
                    const {
                        values,
                        setValues,
                        handleSubmit,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                        validateForm,
                        isValid,
                        errors
                    } = formik;
                    ref.current = { validateForm, handleSubmit, isValid, values, errors };

                    return (
                        <div className="px-sm overflow-x-hidden-sm">
                            <FormikEffect onChange={handleChange} />
                            {hasDoublePromotion && <div className="Toastify__toast_info">
                                <Toast type='info' message="Estimado cliente, tiene a su disposición dos descuentos (Oferta y Referido). Se le aplicará a su solicitud la mayor rebaja." />
                            </div>}

                            <VehicleForm patentes={values.patentes} setFieldValue={setFieldValue} price={price} />
                            <PersonalForm
                                setFieldTouched={setFieldTouched}
                                setFieldValue={setFieldValue}
                                handleBlur={handleBlur}
                                values={values}
                                setValues={setValues}
                                userInfo={userInfo} />
                        </div>
                    )
                }
            }
        </Formik>
    );
});

GeneralData.propTypes = {};

export default GeneralData;
